import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { BaseDialogActionData, ButtonColor, CommonActionKey } from "common";
import { Observable } from "rxjs";

@Component({
    selector: 'ifb-re-amortize-dialog',
    templateUrl: './re-amortize-dialog.component.html',
    standalone: false
})
export class ReAmortizeDialogComponent {
  actions: BaseDialogActionData[] = [
    { actionKey: CommonActionKey.Cancel, label: 'Cancel', buttonColor: ButtonColor.Default },
    { actionKey: CommonActionKey.Ok, label: 'Ok', buttonColor: ButtonColor.Primary },
  ];
  
  constructor(public dialogRef: MatDialogRef<ReAmortizeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  static show(dialog: MatDialog, paymentAmount: number, numberOfPaymentsLeft: number, paymentDueDate: Date, loanNumber: string): Observable<any> {
    return dialog.open(ReAmortizeDialogComponent, {
      width: '510px',
      data: {
        paymentAmount,
        numberOfPaymentsLeft,
        paymentDueDate,
        loanNumber
      },
      closeOnNavigation: true,
    }).afterClosed();
  }

  onActionClicked(actionData: BaseDialogActionData): void {
    if (actionData.actionKey === CommonActionKey.Ok) {
      return this.dialogRef.close(true);
    }

    this.dialogRef.close(false);
  }
}
